import { render, staticRenderFns } from "./CompetenceForm.vue?vue&type=template&id=c2848878&scoped=true"
import script from "./CompetenceForm.vue?vue&type=script&lang=js"
export * from "./CompetenceForm.vue?vue&type=script&lang=js"
import style0 from "./CompetenceForm.vue?vue&type=style&index=0&id=c2848878&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2848878",
  null
  
)

export default component.exports